import React from "react";

export const Card = ({ className = "", children }) => (
  <div className={`bg-white dark:bg-zinc-900 rounded-xl ${className}`}>{children}</div>
);

export const CardContent = ({ className = "", children }) => (
  <div className={`p-4 ${className}`}>{children}</div>
);
